module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next-gen-dashboard"
  }, [_c('promotions'), _vm._v(" "), _c('div', {
    staticClass: "next-gen-dashboard__container"
  }, [_c('div', {
    staticClass: "next-gen-dashboard__content"
  }, [_c('div', {
    staticClass: "next-gen-dashboard__listings"
  }, [_c('div', {
    staticClass: "next-gen-dashboard__tasks"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "next-gen-dashboard__tasks--items"
  }, [(!_vm.loadingTasks) ? [(_vm.tasks && _vm.tasks.length) ? [_c('vuescroll', {
    attrs: {
      "ops": _vm.scrollBarOptions
    }
  }, _vm._l((_vm.tasks), function(task) {
    return _c('router-link', {
      key: task.id,
      staticClass: "next-gen-dashboard__tasks--item",
      attrs: {
        "to": {
          name: 'task',
          params: {
            id: task.id
          }
        },
        "aria-label": task.title
      }
    }, [_c('div', {
      staticClass: "next-gen-dashboard__tasks--item-data"
    }, [_c('span', {
      staticClass: "next-gen-dashboard__tasks--item-key",
      class: {
        'line-through': task.status === 4
      }
    }, [_vm._v("\n                    " + _vm._s(task.key) + "\n                  ")]), _vm._v(" "), _c('span', {
      staticClass: "next-gen-dashboard__tasks--item-name"
    }, [_vm._v("\n                    " + _vm._s(task.title) + "\n                  ")])]), _vm._v(" "), _c('div', {
      staticClass: "next-gen-dashboard__tasks--item-meta"
    }, [_c('div', {
      staticClass: "next-gen-dashboard__tasks--item-chapter",
      class: {
        empty: !task.chapter || !_vm.getChapterById(task.chapter)
      }
    }, [(task.chapter && _vm.getChapterById(task.chapter)) ? [_c('div', {
      staticClass: "next-gen-dashboard__tasks--item-chapter-progress"
    }, [_c('div', {
      staticClass: "next-gen-dashboard__tasks--item-chapter-image",
      style: ({
        backgroundImage: _vm.getChapterBackground(_vm.getChapterById(task.chapter))
      })
    }), _vm._v(" "), _c('svg', {
      staticClass: "progress",
      attrs: {
        "width": "130",
        "height": "130",
        "viewBox": "0 0 100 100"
      }
    }, [_c('circle', {
      staticClass: "progress_meter",
      attrs: {
        "cx": "50",
        "cy": "50",
        "r": "44",
        "stroke-width": "5"
      }
    }), _vm._v(" "), _c('circle', {
      staticClass: "progress_value",
      class: 'filters_progress_value-' + _vm.getChapterById(task.chapter)['id'],
      attrs: {
        "cx": "50",
        "cy": "50",
        "r": "44",
        "stroke-width": "5"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "next-gen-dashboard__tasks--item-chapter-name"
    }, [_vm._v(_vm._s(_vm.getChapterById(task.chapter)['name']))])] : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "next-gen-dashboard__tasks--item-meta-user-info"
    }, [_c('div', {
      staticClass: "next-gen-dashboard__tasks--item-meta-properties"
    }, [(task.recurrent) ? _c('div', {
      staticClass: "next-gen-dashboard__tasks--item-meta-property recurrency"
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-sync-alt fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "sync-alt",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328\n                          53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933\n                          94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504\n                          57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382\n                          0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144\n                          162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187\n                          504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"
      }
    })])]) : _vm._e(), _vm._v(" "), (task.mandatory) ? _c('div', {
      staticClass: "next-gen-dashboard__tasks--item-meta-property mandatory"
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-exclamation-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "exclamation-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248\n                          111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418\n                          136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884\n                          0-12.356 5.78-11.981 12.654z"
      }
    })])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "next-gen-dashboard__tasks--item-meta-user priority",
      class: ['priority-' + _vm.taskPriorityDelta(task.score)]
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-arrow-up fa-w-14",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "arrow-up",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 448 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6\n                                              0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.taskPriorityLabelByValue(_vm.taskPriorityDelta(task.score))))])]), _vm._v(" "), _c('div', {
      staticClass: "next-gen-dashboard__tasks--item-meta-user status",
      class: ['status-' + task.status]
    }, [(task.status === 1) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-dot-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "dot-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200\n                              0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0\n                              168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"
      }
    })])] : (task.status === 2) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-spinner fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "spinner",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48\n                              368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49\n                              48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49\n                              48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156\n                              0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48\n                              21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
      }
    })])] : (task.status === 3) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-eye fa-w-18",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "eye",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 576 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4\n                              55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48\n                              241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0\n                              0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"
      }
    })])] : (task.status === 4) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-check-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "check-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8\n                              256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532\n                              89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346\n                              303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068\n                              16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
      }
    })])] : _vm._e(), _vm._v(" "), (_vm.getStatusById(task.status)) ? _c('span', {
      staticClass: "status-text"
    }, [_vm._v(_vm._s(_vm.getStatusById(task.status).name))]) : _vm._e()], 2)])])])
  }), 1)] : [_vm._m(1)]] : [_vm._m(2)], _vm._v(" "), _c('div', {
    staticClass: "next-gen-dashboard__listings--action"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'tasks'
      }
    }
  }, [_vm._v("Go to Backlog")])], 1)], 2)]), _vm._v(" "), _c('div', {
    staticClass: "next-gen-dashboard__articles"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "next-gen-dashboard__articles--items"
  }, [_c('vuescroll', {
    attrs: {
      "ops": _vm.scrollBarOptions
    }
  }, _vm._l((_vm.articles), function(article) {
    return _c('router-link', {
      key: article.id,
      staticClass: "next-gen-dashboard__articles--item",
      attrs: {
        "to": {
          name: 'content',
          params: {
            id: article.id
          }
        },
        "aria-label": article.title
      }
    }, [_c('div', {
      staticClass: "next-gen-dashboard__articles--item--title"
    }, [(article.contentType === 7) ? _c('div', {
      staticClass: "next-gen-dashboard__articles--item--icon",
      class: 'type__' + article.contentType
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "21",
        "height": "21",
        "viewBox": "0 0 21 21"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M22.68,17.019l-7.452-4.53a1.018,1.018,0,0,0-1.511.889v8.807a1.02,1.02,0,0,0,1.511.889L22.68,18.8a1.019,1.019,0,0,0,0-1.779Zm5.6.762a10.5,10.5,0,0,0-10.5-10.5h0a10.5,10.5,0,0,0-10.5,10.5v0a10.5,10.5,0,0,0,10.5,10.5h0a10.5,10.5,0,0,0,10.5-10.5Zm-18.967,0a8.465,8.465,0,0,1,8.462-8.467h0a8.465,8.465,0,0,1,8.467,8.462v0a8.465,8.465,0,0,1-8.462,8.467h0a8.465,8.465,0,0,1-8.467-8.462Z",
        "transform": "translate(-7.281 -7.281)"
      }
    })])]) : (article.contentType === 8) ? _c('div', {
      staticClass: "next-gen-dashboard__articles--item--icon",
      class: 'type__' + article.contentType
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "15.746",
        "height": "21.004",
        "viewBox": "0 0 15.746 21.004"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M24.417,11.02,20.972,7.579A1.97,1.97,0,0,0,19.582,7H11.219A1.975,1.975,0,0,0,9.25,8.974V26.032A1.969,1.969,0,0,0,11.219,28h11.81A1.97,1.97,0,0,0,25,26.032V12.414A1.982,1.982,0,0,0,24.417,11.02Zm-1.55,1.234h-3.12V9.134ZM11.219,26.032V8.974H17.78v4.264a.982.982,0,0,0,.98.984h4.269v11.81H11.219ZM21.483,20.14c-.511-.492-1.933-.363-2.645-.267a3.551,3.551,0,0,1-1.509-1.9,5.165,5.165,0,0,0,.222-2.3.914.914,0,0,0-1.75-.241,5.915,5.915,0,0,0,.289,2.751,33.027,33.027,0,0,1-1.451,3.051c-.816.422-1.927,1.074-2.091,1.894-.135.647,1.066,2.264,3.12-1.283a20.322,20.322,0,0,1,2.8-.825,5.45,5.45,0,0,0,2.288.7.947.947,0,0,0,.723-1.585h0Zm-8.128,3.19A4.918,4.918,0,0,1,14.6,21.9C13.822,23.136,13.354,23.358,13.354,23.33ZM16.7,15.515c.3,0,.275,1.317.073,1.673a3.433,3.433,0,0,1-.073-1.674Zm-1,5.6a16.12,16.12,0,0,0,1.012-2.242,4.513,4.513,0,0,0,1.235,1.456,13.949,13.949,0,0,0-2.248.786Zm5.4-.205s-.205.247-1.524-.315c1.433-.11,1.671.218,1.524.315Z",
        "transform": "translate(-9.25 -6.996)"
      }
    })])]) : (article.contentType === 9) ? _c('div', {
      staticClass: "next-gen-dashboard__articles--item--icon",
      class: 'type__' + article.contentType
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "15.75",
        "height": "21",
        "viewBox": "0 0 15.75 21"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M21.063,17.172a.493.493,0,0,0-.495-.492H13.683a.494.494,0,0,0-.492.492V18.32a.494.494,0,0,0,.492.492h6.883a.494.494,0,0,0,.492-.492Zm-.5,2.953H13.683a.494.494,0,0,0-.492.492v1.148a.494.494,0,0,0,.492.492h6.883a.494.494,0,0,0,.492-.492V20.617A.494.494,0,0,0,20.567,20.125ZM25,12.41a1.959,1.959,0,0,0-.583-1.385L20.975,7.583A1.97,1.97,0,0,0,19.584,7H11.219A1.97,1.97,0,0,0,9.25,8.969V26.032A1.969,1.969,0,0,0,11.219,28H23.032A1.971,1.971,0,0,0,25,26.032ZM19.75,9.129l3.121,3.121H19.75Zm3.282,16.9H11.219V8.969h6.563v4.265a.982.982,0,0,0,.98.985h4.27Z",
        "transform": "translate(-9.25 -7)"
      }
    })])]) : (article.contentType === 10) ? _c('div', {
      staticClass: "next-gen-dashboard__articles--item--icon",
      class: 'type__' + article.contentType
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "23.627",
        "height": "21",
        "viewBox": "0 0 23.627 21"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M20219.232-8589a.984.984,0,0,1-.98-.984.985.985,0,0,1,.98-.985h2.955l.656-1.971h-7.873a1.969,1.969,0,0,1-1.971-1.966v-13.128a1.969,1.969,0,0,1,1.971-1.966h19.686a1.969,1.969,0,0,1,1.971,1.966v13.128a1.976,1.976,0,0,1-1.971,1.971h-7.877l.66,1.966h2.951a.982.982,0,0,1,.949.949.986.986,0,0,1-.949,1.021Zm-3.605-6.566H20234v-11.813h-18.375Zm3.209-2.479a.581.581,0,0,1-.584-.584v-1.163a.581.581,0,0,1,.584-.584h7a.58.58,0,0,1,.58.584v1.163a.58.58,0,0,1-.58.584Zm0-4.667a.581.581,0,0,1-.584-.584v-1.163a.581.581,0,0,1,.584-.584h10.5a.584.584,0,0,1,.584.584v1.163a.584.584,0,0,1-.584.584Z",
        "transform": "translate(-20213 8609.998)"
      }
    })])]) : (article.contentType === 11) ? _c('div', {
      staticClass: "next-gen-dashboard__articles--item--icon",
      class: 'type__' + article.contentType
    }, [_c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "18.53",
        "height": "22.876",
        "viewBox": "0 0 18.53 22.876"
      }
    }, [_c('g', {
      attrs: {
        "transform": "translate(-8 -6.124)"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M18.744,14.421H11.87a.493.493,0,0,0-.492.492v1.147a.493.493,0,0,0,.492.492h6.425a5.959,5.959,0,0,1,.886-.275.486.486,0,0,0,.056-.217l0-1.147a.493.493,0,0,0-.5-.492Z",
        "transform": "translate(0.517 1.307)"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M11.378,17.866v1.147a.493.493,0,0,0,.492.492h3a6.083,6.083,0,0,1,1.4-2.13h-4.4A.493.493,0,0,0,11.378,17.866Z",
        "transform": "translate(0.526 1.772)"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M9.967,25.007V8.078h6.554V12.31a.978.978,0,0,0,.979.977h4.264v4.19a6.065,6.065,0,0,1,1.966.552V11.491a1.937,1.937,0,0,0-.583-1.374L19.71,6.7a1.974,1.974,0,0,0-1.389-.579H9.967A1.961,1.961,0,0,0,8,8.078V25.007A1.961,1.961,0,0,0,9.967,26.96h6.152a5.993,5.993,0,0,1-.9-1.953Zm8.52-16.77,3.117,3.1H18.486Z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M25.194,25.933l-1.815-1.815a.44.44,0,0,0-.31-.127h-.3a3.787,3.787,0,0,0-2.983-6.117h0A3.786,3.786,0,0,0,16,21.658v0a3.786,3.786,0,0,0,3.784,3.787h0a3.763,3.763,0,0,0,2.33-.8v.3a.44.44,0,0,0,.127.31l1.815,1.814a.437.437,0,0,0,.615,0l0,0,.515-.516A.441.441,0,0,0,25.194,25.933Zm-5.407-1.942a2.33,2.33,0,1,1,2.33-2.33A2.33,2.33,0,0,1,19.787,23.991Z",
        "transform": "translate(1.21 1.803)"
      }
    })])])]) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v(_vm._s(article.title))])]), _vm._v(" "), _c('div', {
      staticClass: "next-gen-dashboard__articles--item--text",
      domProps: {
        "innerHTML": _vm._s(_vm.articleText(article.content))
      }
    })])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "next-gen-dashboard__listings--action"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'knowledge-base'
      }
    }
  }, [_vm._v("Go to Inclusion hub")])], 1)], 1)])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next-gen-dashboard__listings--title"
  }, [_c('i', {
    staticClass: "fas fa-stream"
  }), _vm._v(" "), _c('h2', [_vm._v("My tasks")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next-gen-dashboard__tasks--empty"
  }, [_c('div', {
    staticClass: "next-gen-dashboard__tasks--empty__icon"
  }, [_c('i', {
    staticClass: "fas fa-thumbtack"
  })]), _vm._v(" "), _c('div', {
    staticClass: "next-gen-dashboard__tasks--empty__text"
  }, [_vm._v("\n                    There are no tasks assigned to you yet\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next-gen-dashboard__tasks--empty"
  }, [_c('div', {
    staticClass: "next-gen-dashboard__tasks--empty__icon"
  }, [_c('i', {
    staticClass: "fas fa-spinner fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "next-gen-dashboard__tasks--empty__text"
  }, [_vm._v("\n                  Loading tasks assigned to you\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next-gen-dashboard__listings--title"
  }, [_c('i', {
    staticClass: "fas fa-pen"
  }), _vm._v(" "), _c('h2', [_vm._v("Latest resources")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53e61a67","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Admin/NextGenDashboard.vue
// module id = 996
// module chunks = 0